import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { Logo } from "./Logo";
import { HOST } from "../data/content";

const LINKS = [
  { label: "About", href: "#about" },
  { label: "Properties", href: "#properties" },
  { label: "Reviews", href: "#reviews" },
];

export const Header = () => {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <motion.header
      data-testid="main-nav-bar"
      initial={{ y: -70, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.9, delay: 0.2, ease: [0.22, 1, 0.36, 1] }}
      className={`fixed inset-x-0 top-0 z-50 transition-[background-color,border-color,backdrop-filter] duration-500 ${
        scrolled
          ? "border-b border-[#E4DBD0] bg-[#FBF8F3]/80 backdrop-blur-xl"
          : "border-b border-transparent bg-transparent"
      }`}
    >
      <div className="mx-auto flex max-w-7xl items-center justify-between px-6 py-4 lg:px-10">
        <a href="#top" data-testid="nav-home-link" aria-label="ALMAH Stays home">
          <Logo />
        </a>
        <nav className="hidden items-center gap-9 md:flex" aria-label="Primary">
          {LINKS.map((link) => (
            <a
              key={link.href}
              href={link.href}
              data-testid={`nav-link-${link.label.toLowerCase()}`}
              className="link-line font-mono-accent text-[11px] uppercase tracking-[0.22em] text-[#63584E] transition-colors duration-300 hover:text-[#201B17]"
            >
              {link.label}
            </a>
          ))}
        </nav>
        <a
          href={HOST.airbnbProfile}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="nav-airbnb-button"
          className="group inline-flex items-center gap-2 rounded-full bg-[#201B17] px-5 py-2.5 text-xs font-medium tracking-wide text-[#FBF8F3] transition-colors duration-300 hover:bg-[#C4623C]"
        >
          View on Airbnb
          <ArrowUpRight className="h-3.5 w-3.5 transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
        </a>
      </div>
    </motion.header>
  );
};
